(() => {
  const selector = '[data-crl-mobile-quick-add]';

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(selector);
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      const form = button.closest('form');
      const variantId = button.dataset.variantId || form?.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      addVariant(button, variantId);
    },
    true
  );

  async function addVariant(button, variantId) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const spinner = button.querySelector('.loading__spinner');
    const config = fetchConfig('javascript');
    const formData = new FormData();

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    spinner?.classList.remove('hidden');

    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(button);
    }

    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    try {
      const response = await fetch(routes.cart_add_url, config);
      const data = await response.json();

      if (data.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'crl-mobile-quick-add',
          productVariantId: variantId,
          errors: data.errors || data.description,
          message: data.message,
        });
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'crl-mobile-quick-add',
        productVariantId: variantId,
        cartData: data,
      });

      if (cart) {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
    }
  }
})();
